import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center px-6 py-8 relative bg-white" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-8 flex gap-3 text-base" }
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = { class: "text-lg font-semibold leading-6 text-gray-900" }

import { onBeforeUnmount, onMounted, ref} from "vue";
// Importing a file upload component
import FileUploadWidgetComponent from "../components/FileUploadWidgetComponent.vue";
// Importing the school store for state management
import { useSchoolStore } from "@/stores/schoolStore";
import { School } from "@/interfaces/school.interface";
import { SchoolStructure } from "@/interfaces/school-structure.interface";
import { useSubjectStore } from "@/stores/subjectStore";
import { Subject } from "@/interfaces/subject.interface";
import { NewLearner } from "@/interfaces/new-learner.interface";

// Define props that the component accepts

export default /*#__PURE__*/_defineComponent({
  __name: 'BulkLearnersUploadComponent',
  props: {
  uploadType: {
    type: String,
  },
  classId: {
    type: String,
  },
  className: {
    type: String,
  },
  grade: {
    type: Number,
  },
},
  emits: [
  "transmitLearnersToUpload",
  "closeUploadModal",
  "resetModalState",
  "resetState",
  "localModalOpen",
],
  setup(__props, { emit }) {

const props = __props;



// Reactive references to manage the component's state
const showGenerateEmails = ref(false);
const generateEmails = ref(false);
const showFileUploadModal = ref(false);
const showUploadedLearnersModal = ref(false);
const uploadedLearners = ref<NewLearner>();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();

// Emit events to parent components


// Lifecycle hook that runs when the component is mounted
onMounted(() => {
  showGenerateEmails.value = true;
});

onBeforeUnmount(() => {
  emit("resetState");
});

// Function to handle the reception of uploaded learners from the FileUploadWidgetComponent
const receiveUploadedLearners = (learners: NewLearner) => {
  console.log("learners in bulklearnersupload: ", learners);
  showUploadedLearnersModal.value = true;
  uploadedLearners.value = learners;
  emit("transmitLearnersToUpload", uploadedLearners.value);
  emit("closeUploadModal", true);
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl px-4 py-6 rounded-lg',
      open: showGenerateEmails.value,
      onLocalModalOpen: _cache[2] || (_cache[2] = (val) => { showGenerateEmails.value = val; if (!val) emit('localModalOpen', false); })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-question-speech-bubble',
              title: 'rl question speech bubble',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h1", {
            class: "mt-5 font-medium text-lg text-gray-900 text-center",
            innerHTML: 
          _ctx.$t(
            'bulk_learner_upload_component.generate_emails_modal.header',
            {
              uploadType:
                props.uploadType == 'grade'
                  ? _ctx.$t(
                      'bulk_learner_upload_component.generate_emails_modal.grade_label'
                    )
                  : _ctx.$t(
                      'bulk_learner_upload_component.generate_emails_modal.class_label'
                    ),
            }
          )
        
          }, null, 8, _hoisted_2),
          _createElementVNode("p", {
            class: "font-normal text-sm text-gray-600 mt-4 text-center",
            innerHTML: 
          _ctx.$t(
            'bulk_learner_upload_component.generate_emails_modal.sub_header'
          )
        
          }, null, 8, _hoisted_3),
          _createElementVNode("p", {
            class: "font-normal text-sm text-gray-600 mt-4",
            innerHTML: 
          _ctx.$t(
            'bulk_learner_upload_component.generate_emails_modal.email'
          )
        
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
            (generateEmails.value = false),
              (showFileUploadModal.value = true),
              (showGenerateEmails.value = false)
          ))
            }, _toDisplayString(_ctx.$t(
              "bulk_learner_upload_component.generate_emails_modal.btn_yes"
            )), 1),
            _createElementVNode("button", {
              class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (
            (generateEmails.value = true),
              (showFileUploadModal.value = true),
              (showGenerateEmails.value = false)
          ))
            }, _toDisplayString(_ctx.$t(
              "bulk_learner_upload_component.generate_emails_modal.btn_generate"
            )), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl px-4 py-6 rounded-lg',
      open: showFileUploadModal.value,
      onLocalModalOpen: _cache[4] || (_cache[4] = (val) => { showFileUploadModal.value = val; if (!val) emit('localModalOpen', false); })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t(
            "bulk_learner_upload_component.generate_emails_modal.file_upload_header",
            {
              uploadType:
                props.uploadType == "grade"
                  ? _ctx.$t(
                      "bulk_learner_upload_component.generate_emails_modal.grade_label"
                    )
                  : _ctx.$t(
                      "bulk_learner_upload_component.generate_emails_modal.class_label"
                    ),
            }
          )), 1),
          _createVNode(FileUploadWidgetComponent, {
            grade: props.grade,
            uploadType: props.uploadType,
            classGroupId: props.classId,
            shouldGenerateEmail: generateEmails.value,
            subjects: (_unref(subjectStore).subjects as Subject[]),
            schoolData: (_unref(schoolStore).currentSchool as School),
            schoolStructure: (_unref(schoolStore).currentSchoolStructure as SchoolStructure),
            onCloseUploadModal: _cache[3] || (_cache[3] = ($event: any) => (showFileUploadModal.value = false)),
            onTransmitLearnersToUpload: receiveUploadedLearners,
            validate: true
          }, null, 8, ["grade", "uploadType", "classGroupId", "shouldGenerateEmail", "subjects", "schoolData", "schoolStructure"])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})